import { Helmet } from "react-helmet-async";
import { type ReactNode } from "react";

interface SEOProps {
  title: string;
  description: string;
  path: string;
  children?: ReactNode;
}

const SITE = "https://saveyspend.com";

export function SEO({ title, description, path, children }: SEOProps) {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {children}
    </Helmet>
  );
}
